import { useTranslation } from "react-i18next";

export default function ProjectReportUd1000PdfCoverIndexPage({
  rows = [],
  showCaption = true,
}) {
  const { t, i18n } = useTranslation();
  const safeRows = Array.isArray(rows) ? rows : [];
  const resolvedLanguage = i18n?.resolvedLanguage ?? i18n?.language ?? "";
  const normalizedLanguage = String(resolvedLanguage).toLowerCase();
  const isEnglishLanguage = normalizedLanguage.startsWith("en");
  const isCompactLanguage = normalizedLanguage.startsWith("vi");
  const baseOrder = safeRows[0]?.order ?? 1;
  const displayRows = Array.from({ length: 15 }, (_, index) => {
    const row = safeRows[index];

    if (row) {
      return row;
    }

    return {
      id: `ud1000-cover-index-empty-${baseOrder + index}`,
      order: baseOrder + index,
      facilityName: "",
      inspectionStatus: "",
      inspectionResult: "",
      pageNumber: "",
    };
  });

  return (
    <div
      className="projectReportUd1000CoverPage is-index"
      data-report-cover="true"
    >
      <div className="projectReportUd1000CoverShell">
        {showCaption ? (
          <div className="projectReportUd1000CoverHeader is-centeredHeader">
            <div className="projectReportUd1000CoverPageTitle">
              {t("projectDetail.projectReportEditor.ud1000Cover.index.title", {
                defaultValue: "\uC735\uD569 \uC810\uAC80 \uBAA9\uB85D \uBC0F \uACB0\uACFC",
              })}
            </div>
          </div>
        ) : null}

        <div className="projectReportUd1000IndexTableWrap">
          <table
            className={[
              "projectReportUd1000IndexTable",
              isCompactLanguage ? "is-compactLanguage" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <thead>
              <tr>
                <th>
                  {t("projectDetail.projectReportEditor.ud1000Cover.index.columns.order", {
                    defaultValue: "\uBC88\uD638",
                  })}
                </th>
                <th>
                  {t(
                    "projectDetail.projectReportEditor.ud1000Cover.index.columns.facilityName",
                    {
                      defaultValue: "\uC124\uBE44\uBA85",
                    },
                  )}
                </th>
                <th className="is-inspectionStatusColumn">
                  {isEnglishLanguage ? (
                    t(
                      "projectDetail.projectReportEditor.ud1000Cover.index.columns.status",
                      {
                        defaultValue: "Status",
                      },
                    )
                  ) : (
                    <>
                      {t(
                        "projectDetail.projectReportEditor.ud1000Cover.index.columns.inspection",
                        {
                          defaultValue: "\uC810\uAC80",
                        },
                      )}
                      <br />
                      {t(
                        "projectDetail.projectReportEditor.ud1000Cover.index.columns.status",
                        {
                          defaultValue: "\uC5EC\uBD80",
                        },
                      )}
                    </>
                  )}
                </th>
                <th className="is-inspectionResultColumn">
                  {isEnglishLanguage ? (
                    t(
                      "projectDetail.projectReportEditor.ud1000Cover.index.columns.result",
                      {
                        defaultValue: "Result",
                      },
                    )
                  ) : (
                    <>
                      {t(
                        "projectDetail.projectReportEditor.ud1000Cover.index.columns.inspection",
                        {
                          defaultValue: "\uC810\uAC80",
                        },
                      )}
                      <br />
                      {t(
                        "projectDetail.projectReportEditor.ud1000Cover.index.columns.result",
                        {
                          defaultValue: "\uACB0\uACFC",
                        },
                      )}
                    </>
                  )}
                </th>
                <th>
                  {t(
                    "projectDetail.projectReportEditor.ud1000Cover.index.columns.pageNumber",
                    {
                      defaultValue: "\uD398\uC774\uC9C0",
                    },
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {displayRows.map((row) => (
                <tr key={row.id}>
                  <td>{row.order}</td>
                  <td>{row.facilityName}</td>
                  <td className="is-inspectionStatusColumn">
                    {row.inspectionStatus}
                  </td>
                  <td className="is-inspectionResultColumn">
                    {row.inspectionResult}
                  </td>
                  <td>{row.pageNumber}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
